import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {CountryModel} from '../../../api/entity/country.model';
import {CountryConverter} from '../../../api/entity/converter/country.converter';


@Injectable({providedIn: 'root'})
export class CountryDataService extends AbstractDataServiceV2<CountryModel, CountryConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: CountryConverter) {
        super('Country', http, httpUrlGenerator, logger, config, converter);
    }
}
